import { Autocomplete, TextField } from '@mui/material';

import { Queue } from '@/tracker/types';
import { getQueueLabel } from '@/tracker/utils/optionGetters';

type Props = {
  value: string;
  onChange: (key: string) => void;
  queues: Queue[];
  isLoading: boolean;
  isError: boolean;
};

/** Очередь новой задачи: выбор из всех доступных с поиском по ключу и названию */
const QueueSelect: React.FC<Props> = ({ value, onChange, queues, isLoading, isError }) => (
  <Autocomplete
    size="small"
    sx={{ width: 320 }}
    options={queues}
    loading={isLoading}
    loadingText="Загрузка…"
    noOptionsText="Очередей не нашлось"
    value={queues.find((queue) => queue.key === value) ?? null}
    getOptionLabel={getQueueLabel}
    isOptionEqualToValue={(option, selected) => option.key === selected.key}
    onChange={(_, queue) => onChange(queue?.key ?? '')}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder="Очередь"
        error={isError}
        slotProps={{ htmlInput: { ...params.inputProps, 'aria-label': 'Очередь' } }}
      />
    )}
  />
);

export { QueueSelect };
